// extracted by mini-css-extract-plugin
export default {"container":"Button_container__i0lye","primary":"Button_primary__SQ4Uf","selected":"Button_selected__9BTDA","default":"Button_default__4syEk"};